import indexOf from 'lodash/indexOf';
import map from 'lodash/map';

/**
 * @param {Array<Object>} array
 * @param {String} field
 * @param {any} value
 * @return {Number|null}
 */
export function indexByObjectValue(array, field, value) {
    const index = indexOf(map(array, (object) => object[field]), value);
    return index !== -1 ? index : null;
}
